import { useEffect, useState } from "react";

/** Aerospace HUD: persistent telemetry overlay that frames the entire site. */
export default function HUD() {
  const [time, setTime] = useState("--:--:-- UTC");
  const [coord, setCoord] = useState("00.0000° N · 000.0000° W");
  const [stardate, setStardate] = useState("");

  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const t = d.toISOString().slice(11, 19);
      setTime(`${t} UTC`);
      // Synthetic coordinate that gently drifts so it feels live
      const lat = (34.0522 + Math.sin(d.getTime() / 60000) * 0.0008).toFixed(4);
      const lng = (118.2437 + Math.cos(d.getTime() / 60000) * 0.0008).toFixed(4);
      setCoord(`${lat}° N · ${lng}° W`);
      // Stardate = days since 2000
      const days = Math.floor((d - new Date("2000-01-01")) / 86400000);
      setStardate(`SD.${days}.${d.getUTCHours().toString().padStart(2, "0")}${d.getUTCMinutes().toString().padStart(2, "0")}`);
    };
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <>
      {/* Corner brackets */}
      <div className="fixed inset-4 pointer-events-none z-30 hidden lg:block" data-testid="hud-frame">
        {["top-0 left-0", "top-0 right-0", "bottom-0 left-0", "bottom-0 right-0"].map((pos, i) => (
          <div key={i} className={`absolute ${pos} w-4 h-4`}>
            <div className={`absolute ${pos.includes("top") ? "top-0" : "bottom-0"} ${pos.includes("left") ? "left-0" : "right-0"} w-3 h-px bg-white/40`} />
            <div className={`absolute ${pos.includes("top") ? "top-0" : "bottom-0"} ${pos.includes("left") ? "left-0" : "right-0"} h-3 w-px bg-white/40`} />
          </div>
        ))}
      </div>

      {/* Side telemetry strips */}
      <div className="fixed left-2 top-1/2 -translate-y-1/2 pointer-events-none z-30 hidden lg:flex flex-col gap-3 font-mono text-[9px] tracking-[0.4em] text-neutral-600">
        <div style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>JITSUENT // CALLSIGN: BONSAI-01</div>
      </div>
      <div className="fixed right-2 top-1/2 -translate-y-1/2 pointer-events-none z-30 hidden lg:flex flex-col gap-3 font-mono text-[9px] tracking-[0.4em] text-neutral-600">
        <div style={{ writingMode: "vertical-rl" }}>{stardate}</div>
      </div>

      {/* Bottom telemetry bar */}
      <div className="fixed bottom-0 left-0 right-0 z-30 pointer-events-none border-t border-neutral-900 bg-black/60 backdrop-blur-md hidden md:block" data-testid="hud-bottom">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-2 grid grid-cols-12 gap-4 items-center font-mono text-[9px] tracking-[0.3em] text-neutral-500">
          <div className="col-span-2 flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-white rounded-full flicker" /> SIGNAL.LOCK
          </div>
          <div className="col-span-3">{coord}</div>
          <div className="col-span-3 text-center text-neutral-400">JOINT OSS · 4EVER ROLLIN' · ROLL READY</div>
          <div className="col-span-2 text-right">MACH 9.6</div>
          <div className="col-span-2 text-right text-white">{time}</div>
        </div>
      </div>
    </>
  );
}
